/* eslint-disable ember/use-ember-data-rfc-395-imports */
import type { Snapshot } from '@ember-data/store';
import type { ModelRegistry } from 'ember-data/model';

import ApplicationAdapter from './application';

export default class extends ApplicationAdapter {
  urlForFindRecord<K extends keyof ModelRegistry>(id: string, _modelName: K, snapshot: Snapshot<K>): string {
    return `${super.urlForFindRecord(id, 'invite', <Snapshot<'invite'>>snapshot)}/invite-template`;
  }
}
